import React, { useState } from 'react'
import { useEffect } from 'react'
import Modal from '../../controls/Modal'
import LodingButton from '../../controls/LodingButton'
import { useFormik } from 'formik'
import Input from '../../controls/Input'
import * as yup from 'yup'
import { useToast } from '../../controls/Toast/ToastService'
import { GetAll } from '../../../configurations/crud/doctorsSpecialisation'
import { MdErrorOutline } from 'react-icons/md'
import { GetEBool } from '../../../configurations/enums/EBool'
import * as stateCrud from '../../../configurations/crud/stateCrud'
import * as cityCrud from '../../../configurations/crud/cityCrud'
import { GetEGender } from '../../../configurations/enums/EGender'
import { FaAddressCard, FaBriefcaseMedical, FaUserGraduate } from 'react-icons/fa'
import { FcLeave } from "react-icons/fc";
import { FaLocationDot, FaMapLocationDot, FaUserDoctor } from "react-icons/fa6";
import Select from '../../controls/Select'
import { MdMedicalInformation } from "react-icons/md";
import { BsGenderAmbiguous } from 'react-icons/bs'
import { MdTextsms } from "react-icons/md";
import { RiLandscapeFill } from "react-icons/ri";
import { FaNoteSticky } from "react-icons/fa6";
import useGlobalLoader from '../../../configurations/useGlobalLoader'

const schema = yup.object().shape({
    fullName: yup.string().required("Full name is required"),
    degree: yup.string().required("Degree is required"),
    specialisationId: yup.string().required("SpecialisationId is required"),
    experiance: yup.string().required("Experience is required"),
    gender: yup.string().required("Gender is required"),
    isOnLeave: yup.string().required("isOnLeave is required"),
    cityId: yup.string().required("cityId is required"),
    address: yup.string().required("Address is required"),
})

export default function UpdateUser({ isOpen, setIsOpen, editData, EditProfileData, loading }) {
    const { start, end } = useGlobalLoader()
    const [specialisationData, setSpecialisationData] = useState([])
    const [loding, setLoding] = useState(false)
    const [lodingCityCrud, setLodingCityCrud] = useState(false)
    const [cityData, setCityData] = useState([]);
    const [lodingStateCrud, setLodingStateCrud] = useState(false)
    const [stateData, setStateData] = useState([])
    const toast = useToast()

    const { values, handleBlur, handleChange, handleSubmit, errors, touched, isValid, setValues } = useFormik({
        initialValues: {
            userId: "",
            fullName: "",
            degree: "",
            specialisationId: "0",
            experiance: 0,
            gender: 0,
            isOnLeave: 0,
            isSmsActive: 0,
            leaveNote: "N/A",
            cityId: 0,
            stateId: 0,
            address: "",
        },
        validationSchema: schema,
        onSubmit(val) {
            const payload = {
                ...val,
                userId: editData.userId
            }
            EditProfileData(payload, setValues)
        }
    })

    useEffect(() => {
        GetSpecialisations();
        GetStates();
    }, []);

    useEffect(() => {
        if (editData) {
            if (editData.city?.stateId)
                setValues({
                    ...editData,
                    cityId: editData.cityId,
                    stateId: editData.city.stateId,
                });
        }
    }, [editData]);

    const GetSpecialisations = () => {
        setLoding(true)
        start()
        GetAll().then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setSpecialisationData(mdata.data)
            } else {
                setSpecialisationData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLoding(false)
            end()
        }).catch(errors => {
            setSpecialisationData([])
            setLoding(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    const GetStates = () => {
        setLodingStateCrud(true)
        start()
        stateCrud.GetAll().then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setStateData(mdata.data)
            } else {
                setStateData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLodingStateCrud(false)
            end()
        }).catch(errors => {
            setStateData([])
            // toast.open("errors", <MdErrorOutline />, "danger")
            setLodingStateCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    useEffect(() => {
        if (stateData.length > 0 && values.stateId != 0) {
            GetCities()
        }
        //setValues({ ...values, cityId: "" })
    }, [values.stateId])

    const GetCities = () => {
        setLodingCityCrud(true)
        start()
        cityCrud.GetAll(values.stateId).then(res => {
            let mdata = res.data
            if (mdata.result.succeeded) {
                setCityData(mdata.data)
            } else {
                setCityData([])
                toast.open(mdata.result.message, <MdErrorOutline />, "danger")
            }
            setLodingCityCrud(false)
            end()
        }).catch(errors => {
            setCityData([])
            // toast.open(errors, <MdErrorOutline />, "danger")
            setLodingCityCrud(false)
            end()
            toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
        })
    }

    return (
        <Modal isOpen={isOpen} setIsOpen={setIsOpen} title={"Manage Profile"}>
            <form onSubmit={handleSubmit}>
                <div class="p-6 space-y-6">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <div >
                            <label for="fullName" class="block mb-2 text-sm font-medium text-gray-900 ">Full Name</label>
                            <Input placeholder="Full Name"
                                id="fullName"
                                Icon={<FaUserDoctor className='text-green-500' />}
                                value={values.fullName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.fullName && touched.fullName}
                            />
                            {errors.fullName && touched.fullName && <p className='text-red-600 text-xs'>{errors.fullName}</p>}
                        </div>

                        <div>
                            <label for="degree" class="block mb-2 text-sm font-medium text-gray-900">Degree</label>
                            <Input placeholder="Degree"
                                id="degree"
                                Icon={<FaUserGraduate className='text-blue-500 text-md' />}
                                value={values.degree}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.degree && touched.degree}
                            />
                            {errors.degree && touched.degree && <p className='text-red-600 text-xs'>{errors.degree}</p>}
                        </div>
                        <div>
                            <label for="specialisationId" class="block mb-2 text-sm font-medium text-gray-900 ">Specialisation</label>
                            <Select
                                Icon={<MdMedicalInformation className='text-cyan-500 text-lg' />}
                                id="specialisationId"
                                value={values.specialisationId}
                                onChange={handleChange}
                                onBlur={handleBlur}>
                                {specialisationData.map((items, index) =>
                                    <option value={items.id}>{items.name}({items.shortName})</option>
                                )}
                            </Select>
                            {errors.specialisationId && touched.specialisationId && <p className='text-red-600 text-xs'>{errors.specialisationId}</p>}
                        </div>
                        <div >
                            <label for="experiance" class="block mb-2 text-sm font-medium text-gray-900 ">Experience</label>
                            <Input placeholder="Experience"
                                id="experiance"
                                Icon={<FaBriefcaseMedical className='text-yellow-500 text-md' />}
                                value={values.experiance}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.experiance && touched.experiance}
                            />
                            {errors.experiance && touched.experiance && <p className='text-red-600 text-xs'>{errors.experiance}</p>}
                        </div>
                        <div >
                            <label for="gender" class="block mb-2 text-sm font-medium text-gray-900 ">Gender</label>
                            <Select
                                Icon={<BsGenderAmbiguous className='text-orange-600 text-lg' />}
                                id="gender"
                                value={values.gender}
                                onChange={handleChange}
                                onBlur={handleBlur}>
                                {GetEGender.EGender.map((items, index) =>
                                    <option value={items.Id}>{items.Name}</option>
                                )}
                            </Select>
                        </div>
                        <div >
                            <label for="isOnLeave" class="block mb-2 text-sm font-medium text-gray-900 ">Is On Leave</label>
                            <Select
                                Icon={<RiLandscapeFill className='text-purple-600 text-lg' />}
                                id="isOnLeave"
                                value={values.isOnLeave}
                                onChange={handleChange}
                                onBlur={handleBlur}>
                                {GetEBool.EBool.map((items, index) =>
                                    <option value={items.Id}>{items.Name}</option>
                                )}
                            </Select>
                            {errors.isOnLeave && touched.isOnLeave && <p className='text-red-600 text-xs'>{errors.isOnLeave}</p>}
                        </div>
                        {/* <div >
                            <label for="isSmsActive" class="block mb-2 text-sm font-medium text-gray-900 ">Is Sms Active</label>
                            <Select
                                Icon={<MdTextsms className='text-yellow-600 text-lg' />}
                                id="isSmsActive"
                                value={values.isSmsActive}
                                onChange={handleChange}
                                onBlur={handleBlur}>
                                {GetEBool.EBool.map((items, index) =>
                                    <option value={items.Id}>{items.Name}</option>
                                )}
                            </Select>
                            {errors.isOnLeave && touched.isOnLeave && <p className='text-red-600 text-xs'>{errors.isOnLeave}</p>}
                        </div> */}
                        <div className='sm:col-span-2'>
                            <label for="leaveNote" class="block mb-2 text-sm font-medium text-gray-900 ">Leave Note</label>
                            <Input placeholder="Leave Note"
                                id="leaveNote"
                                Icon={<FaNoteSticky className='text-red-500 text-md' />}
                                value={values.leaveNote}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.leaveNote && touched.leaveNote}
                            />
                            {errors.leaveNote && touched.leaveNote && <p className='text-red-600 text-xs'>{errors.leaveNote}</p>}
                        </div>
                        <div>
                            <label class="block mb-2 text-sm font-medium text-gray-900 ">State</label>
                            {!lodingStateCrud ?
                                <Select
                                    Icon={<FaMapLocationDot className='text-green-600 text-lg' />}
                                    id="stateId"
                                    value={values.stateId}
                                    onChange={handleChange}
                                    onBlur={handleBlur}>
                                    <option value="" selected>Select state...</option>
                                    {stateData.map((item) =>
                                        <option value={item.id}>{item.name} ({item.shortName})</option>
                                    )}
                                </Select>
                                : <Select disabled
                                    Icon={<FaMapLocationDot className='text-green-600 text-lg' />} >
                                    <option >Loading states...</option>
                                </Select>
                            }
                            {errors.stateId && touched.stateId && <p className='text-red-600 text-xs'>{errors.stateId}</p>}
                        </div>

                        <div>
                            <label class="block mb-2 text-sm font-medium text-gray-900">City</label>
                            {!lodingCityCrud ?
                                <Select
                                    id="cityId"
                                    Icon={<FaLocationDot className='text-brand-600' />}
                                    value={values.cityId}
                                    onChange={handleChange}
                                    onBlur={handleBlur}>
                                    <option value="" selected>Select city...</option>
                                    {cityData.map((item) =>
                                        <option value={item.id}>{item.name} ({item.shortName})</option>
                                    )}
                                </Select>
                                : <Select disabled
                                    Icon={<FaLocationDot className='text-brand-600' />} >
                                    <option >Loading cities...</option>
                                </Select>
                            }
                            {errors.cityId && touched.cityId && <p className='text-red-600 text-xs'>{errors.cityId}</p>}
                        </div>
                        <div className='sm:col-span-2'>
                            <label for="address" class="block mb-2 text-sm font-medium text-gray-900 ">Address</label>
                            <Input placeholder="Address"
                                id="address"
                                Icon={<FaAddressCard className='text-brand-500 text-md' />}
                                value={values.address}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.address && touched.address}
                            />
                            {errors.address && touched.address && <p className='text-red-600 text-xs'>{errors.address}</p>}
                        </div>

                    </div>
                </div>
                <div class="flex items-center p-6 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b ">
                    {!loading ?
                        <button type="submit" className={!isValid ? "btn-blue-disabled" : "btn-blue"} disabled={!isValid}>Save</button>
                        : <LodingButton text="Wait.." />
                    }
                </div>
            </form>
        </Modal >
    )
}
